// extracted by mini-css-extract-plugin
export default {"terms-and-conditions-text":"EHQNr730I4wCPsqZA8kv0g==","terms-and-conditions-link":"MK+VHIx98UbvrJVMNLSZxA==","terms-and-conditions-link-icon":"_1Yj4ekENFyR3FJctS1MKhQ=="};